(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tamecare-promo-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('TamecarePromoPopup');

    if (!popup || typeof popup.showModal !== 'function') return;

    const storageKey = 'tamecare-apparel-bogo50-2026-09-v1';
    const threeDays = 3 * 24 * 60 * 60 * 1000;
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const forcePreview = new URLSearchParams(window.location.search).get('tamecare_popup') === 'apparel';
    let lastClosed = 0;
    let attempts = 0;

    try {
      lastClosed = Number(window.localStorage.getItem(storageKey) || 0);
    } catch (error) {
      lastClosed = 0;
    }

    if (!designMode && !forcePreview && Date.now() - lastClosed < threeDays) return;

    const storeClosedTime = () => {
      if (designMode || forcePreview) return;

      try {
        window.localStorage.setItem(storageKey, String(Date.now()));
      } catch (error) {
        return;
      }
    };

    const closePopup = () => {
      if (popup.open) popup.close();
      storeClosedTime();
    };

    popup.querySelectorAll('[data-tamecare-popup-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    popup.querySelector('[data-tamecare-popup-cta]')?.addEventListener('click', storeClosedTime);
    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });
    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });

    const openPopup = () => {
      if (popup.open) return;

      const anotherDialog = document.querySelector('dialog[open]:not(#TamecarePromoPopup)');
      if (anotherDialog && attempts < 5) {
        attempts += 1;
        window.setTimeout(openPopup, 2000);
        return;
      }

      if (!anotherDialog) {
        popup.showModal();
        popup.focus({ preventScroll: true });
      }
    };

    window.setTimeout(openPopup, forcePreview ? 0 : designMode ? 350 : 2000);
  })();
  } catch(e) { console.error(e); }
})();

})();
